import { Box, CircularProgress } from "@material-ui/core"
import type { ReactElement } from "react"

export function SpinnerContainer(): ReactElement {
  return (
    <Box
      className="spinner-container"
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      padding="3.2rem"
      boxSizing="border-box"
    >
      <CircularProgress />
    </Box>
  )
}
